import tabSliderTabNavMeta from './block.json';
import edit from './edit';
import save from './save';

const { registerBlockType } = wp.blocks;
const { name, ...settings } = tabSliderTabNavMeta;

const attributes = {
  ...settings.attributes,
};

registerBlockType(name, {
  ...settings,
  attributes,
  edit,
  save,
});
